/// <reference path="app.hilo.controllers.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../../common/controllers/screencontrollerbase.ts" />
/// <reference path="hilocontrollerbase.ts" />

module App.HiLO.Controllers {



    'use strict';

    class SellLeaseController extends HiLOControllerBase<Hca.HiLO.ViewModel.IPermissionToSellViewModel> {
        public static $inject = ['$injector'];
        public model: Hca.HiLO.ViewModel.IPermissionToSellViewModel;
        public api: Common.Services.ApiService;
        public selectedExclusionValue: string;
        public questionHelperService: App.HiLO.Services.QuestionHelperService;

        constructor($injector: angular.auto.IInjectorService) {
            super($injector);
            this.model = {
                productName: 'Permission to sell or lease property',

                contactDetails: {
                    contactAddress: {} as Hca.HiLO.ViewModel.IAddressViewModel
                },
                propertyAddress: {} as Hca.HiLO.ViewModel.IAddressViewModel,
                uploadedFiles: []

            } as Hca.HiLO.ViewModel.IPermissionToSellViewModel;

            this.api = $injector.get<Common.Services.ApiService>('app.common.services.apiService');
            this.questionHelperService = $injector.get<App.HiLO.Services.QuestionHelperService>('app.hilo.services.questionHelperService');
            this.title = 'Permission to sell or lease property - Homes England';
            this.titleSecondary = 'Grant Permission to Sell or Lease Property.';

            this.filesToUpload = [
				{ name: 'Current copy of registered title', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
				{ name: 'Current copy of title plan', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
				{ name: 'Copy of the deed', description: '(usually a conveyance or transfer) which imposed the restriction', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false},
				{ name: 'Draft deed of covenant', description: 'required to comply with the restriction', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false }

            ];

            this.questionList = [
                { order: 1, name: 'isuk' },
                { order: 2, name: 'isNotExcluded' },
                { order: 3, name: 'isSection9' },
                { order: 4, name: 'isComplianceCertificationRequired' }, 
                { order: 5, name: 'isgla' },
                { order: 6, name: 'isLandRegistry' }
            ];

            this.currentUpload = this.filesToUpload[0].name;

        }

        public beforeInitialize(): angular.IPromise<any> {
            return this.setAuthenticationRequired(false);
        }

        public initialize(): angular.IPromise<any> {

            return this.$q.resolve();
        }



        public updateSection(value: number, formName: string) {
            this.$window.scrollTo(0, 0);
            this.currentFormName = formName;
            if (this.currentSection < 4 && this.currentSection > -1) {
                this.currentSection = value;
            }

        }


        public disableProductInfo(): boolean {

            var isDisabled;
            if (this.model.includeStandardForm) {
                isDisabled = !this.model.hasCheckedStandardForm;
            }
            else {
                isDisabled = false;
            }
            return isDisabled;

        }

        public save(): angular.IPromise<any> {


            this.userMessages.clear();
            this.$window.scrollTo(0, 0);

            this.refNumberService.getReferenceNumber('C').then((data: string) => {
                this.model.referenceNumber = data;

	            this.model.uploadedFiles = _.filter(this.model.uploadedFiles, x => !(<any>x).skipped);

                //  this.model.referenceNumber = ref;
                this.model.formSubmission = JSON.stringify(this.model);

                var postConfig: Common.IApiRequestConfig = {
                    url: 'api/FormSubmission/PermissionToSell',
                    authenticated: false,
                    data: this.model
                };

                this.busyPromise = this.api.post(postConfig)
                    .then((r: any) => {
                        this.mainForm().$setPristine();
                        this.$state.go('SubmissionComplete', { id: this.model.referenceNumber, product: '3' });
                    });

                return this.$q.resolve();
            });
            return this.$q.resolve();
        }

    }


    angular
        .module('app.hilo.controllers')
        .controller('app.hilo.controllers.sellLeaseController', SellLeaseController);

}